import React from 'react';
import { OptionalArrayField, ReferenceField } from '@uncinc/react-drupal-core/types';
import LinkTags from './LinkTags';

import { TaxonomyThemes } from '../../types/uncinc_profile/taxonomy';

import './style.scss';
import { LinkTagProps } from './LinkTags/LinkTag';

interface ThemesLabelsProps {
  themes: OptionalArrayField<[ReferenceField<TaxonomyThemes>]>;
  isMainTheme?: boolean;
}

const ThemesLabels = ({ themes, isMainTheme = false }: ThemesLabelsProps) => {
  const tagListThemes: Array<LinkTagProps> = [];
  themes.forEach((theme) => {
    const name = theme.entity?.name[0]?.value;
    const url = theme.entity?.paths.nl;

    if (name) {
      tagListThemes.push({
        name,
        url,
      } as LinkTagProps);
    }
  });

  return (
    <LinkTags tags={tagListThemes} className={`${isMainTheme ? 'LinkTags__mainTheme' : ''}`} />
  );
};

export default ThemesLabels;
